import React from 'react';
import PartnersComparisonTable from '../components/PartnersComparisonTable';
import PartnersSectionHeading from '../components/PartnersSectionHeading';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersContrast: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section className="container-chisme py-10 lg:py-16">
      <PartnersSectionHeading
        title={
          <>
            <span className="block">{s.contrast.titleLine1}</span>
            <span className="block italic text-chisme-primary">{s.contrast.titleLine2}</span>
          </>
        }
        subtitle={s.contrast.subtitle}
      />

      <div className="mt-12">
        <PartnersComparisonTable
          rows={s.comparisonRows}
          competitorLabel={s.contrast.competitorLabel}
        />
      </div>
    </section>
  );
};

export default PartnersContrast;
